// src/pages/AdminNicheConfig/index.jsx
import React, { useState, useEffect } from 'react';
import AppLayout from '../../layouts/AppLayout';
import apiClient from '../../lib/apiClient';
import './styles.css';

const NICHES = [
  { value: 'restaurantes', label: 'Restaurantes'  },
  { value: 'varejo',       label: 'Varejo'         },
  { value: 'saude',        label: 'Saúde'          },
  { value: 'educacao',     label: 'Educação'       },
  { value: 'imoveis',      label: 'Imóveis'        },
  { value: 'geral',        label: 'Geral'          },
];

export default function AdminNicheConfigPage() {
  const [config, setConfig]    = useState({});
  const [niche, setNiche]      = useState('restaurantes');
  const [slaAccept, setSlaAccept] = useState(30);
  const [slaDeliver, setSlaDeliver] = useState(120);
  const [platFee, setPlatFee]  = useState(25);
  const [loading, setLoading]  = useState(false);
  const [toast, setToast]      = useState('');
  const [slaResult, setSlaResult] = useState(null);

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  useEffect(() => {
    const load = async () => {
      try {
        const r = await apiClient.request('/admin/config', { method: 'GET' });
        const d = await r.json();
        if (d.success) {
          setConfig(d.config);
          if (d.config.primary_niche) setNiche(d.config.primary_niche);
          if (d.config.sla_accept_minutes) setSlaAccept(Number(d.config.sla_accept_minutes));
          if (d.config.sla_deliver_hours)  setSlaDeliver(Number(d.config.sla_deliver_hours) * 60);
          if (d.config.platform_fee_pct)   setPlatFee(Number(d.config.platform_fee_pct));
        }
      } catch {}
    };
    load();
  }, []);

  const save = async (key, value) => {
    setLoading(true);
    try {
      const r = await apiClient.request('/admin/config', {
        method: 'POST',
        body: JSON.stringify({ key, value }),
      });
      const d = await r.json();
      if (d.success) {
        showToast(`${key} atualizado para: ${value}`);
        setConfig(prev => ({ ...prev, [key]: value }));
      }
    } catch { showToast('Erro ao salvar'); }
    finally { setLoading(false); }
  };

  const runSlaCheck = async () => {
    try {
      const r = await apiClient.request('/sla/check', { method: 'POST' });
      const d = await r.json();
      setSlaResult(d);
      showToast(`SLA verificado: ${d.refunded_jobs} devolvidos, ${d.penalized_specs} penalizados`);
    } catch { showToast('Erro no SLA check'); }
  };

  const certifySpecialist = async () => {
    const uid = window.prompt('User ID do especialista a certificar:');
    if (!uid) return;
    try {
      const r = await apiClient.request('/specialist/certify', {
        method: 'POST',
        body: JSON.stringify({ user_id: uid, certified: true }),
      });
      const d = await r.json();
      showToast(d.certified ? `${uid} certificado!` : 'Erro');
    } catch {}
  };

  return (
    <AppLayout title="Admin — Configuração MP" subtitle="Nicho, SLA, comissão e ferramentas de admin" fullWidth>
      {toast && <div className="anc-toast">{toast}</div>}

      {/* Nicho Principal */}
      <div className="anc-card">
        <h3 className="anc-card__title">Nicho Principal</h3>
        <p className="anc-card__sub">O nicho define os prompts da IA, os especialistas ativos e os templates de landing page.</p>
        <div className="anc-niche-grid">
          {NICHES.map(n => (
            <button key={n.value}
              className={`anc-niche-btn${niche === n.value ? ' anc-niche-btn--active' : ''}`}
              onClick={() => setNiche(n.value)}>
              {n.label}
            </button>
          ))}
        </div>
        <button className="anc-btn anc-btn--save" onClick={() => save('primary_niche', niche)} disabled={loading}>
          Salvar nicho
        </button>
        {config.primary_niche && (
          <div className="anc-current">Nicho atual: <strong>{config.primary_niche}</strong></div>
        )}
      </div>

      {/* SLA */}
      <div className="anc-card">
        <h3 className="anc-card__title">SLA — Prazos</h3>
        <div className="anc-grid">
          <div>
            <label className="anc-label">Aceitar job em (minutos)</label>
            <input className="anc-input" type="number" min={5} max={120}
              value={slaAccept} onChange={e => setSlaAccept(Number(e.target.value))} />
            <button className="anc-btn anc-btn--sm" onClick={() => save('sla_accept_minutes', slaAccept)}>Salvar</button>
          </div>
          <div>
            <label className="anc-label">Entregar job em (minutos)</label>
            <input className="anc-input" type="number" min={30} max={480}
              value={slaDeliver} onChange={e => setSlaDeliver(Number(e.target.value))} />
            <button className="anc-btn anc-btn--sm" onClick={() => save('sla_deliver_hours', slaDeliver / 60)}>Salvar</button>
          </div>
        </div>
        <button className="anc-btn anc-btn--sla" onClick={runSlaCheck}>
          Rodar verificação SLA agora
        </button>
        {slaResult && (
          <div className="anc-sla-result">
            Jobs cancelados + créditos devolvidos: <strong>{slaResult.refunded_jobs}</strong> &nbsp;|&nbsp;
            Especialistas penalizados: <strong>{slaResult.penalized_specs}</strong>
          </div>
        )}
      </div>

      {/* Comissão */}
      <div className="anc-card">
        <h3 className="anc-card__title">Comissão da Plataforma</h3>
        <div className="anc-commission-row">
          <div>
            <label className="anc-label">Taxa da plataforma (%)</label>
            <input className="anc-input anc-input--sm" type="number" min={0} max={50}
              value={platFee} onChange={e => setPlatFee(Number(e.target.value))} />
            <button className="anc-btn anc-btn--sm" onClick={() => save('platform_fee_pct', platFee)}>Salvar</button>
          </div>
          <div className="anc-commission-preview">
            <div className="anc-comm-bar">
              <div className="anc-comm-spec" style={{ width: `${100 - platFee}%` }}>{100 - platFee}% Especialista</div>
              <div className="anc-comm-plat" style={{ width: `${platFee}%` }}>{platFee}% Plataforma</div>
            </div>
          </div>
        </div>
      </div>

      {/* Certificar especialista */}
      <div className="anc-card">
        <h3 className="anc-card__title">Certificar Especialista</h3>
        <p className="anc-card__sub">Especialistas só aceitam jobs após certificação manual.</p>
        <button className="anc-btn anc-btn--cert" onClick={certifySpecialist}>
          Certificar especialista por ID
        </button>
      </div>

      {/* Config raw */}
      {Object.keys(config).length > 0 && (
        <div className="anc-card">
          <h3 className="anc-card__title">Configurações ativas</h3>
          <pre className="anc-pre">{JSON.stringify(config, null, 2)}</pre>
        </div>
      )}
    </AppLayout>
  );
}
